/**
 * Mock Data: Merchant Points Table
 * Mock data for points per merchant
 *
 * Corresponds to Postman endpoint: GET /product/api/v1/dashboard/merchant-points
 */

import type { MerchantPointsApiResponse } from '../data/remote/response';

// Re-export types from response module for backward compatibility
export type { MerchantPointData, MerchantPointsApiResponse } from '../data/remote/response';

// Legacy alias for backward compatibility
export type MerchantPointsResponse = MerchantPointsApiResponse;

export const mockMerchantPointsData: MerchantPointsApiResponse = {
  data: [
    {
      merchantId: "M001",
      name: "Kopi Kangen",
      logoUrl:
        "https://images.unsplash.com/photo-1511920170033-f8396924c348?w=80&h=80&fit=crop",
      branchCount: 10,
      points: 400000,
    },
    {
      merchantId: "M002",
      name: "Bento Oke",
      logoUrl:
        "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=80&h=80&fit=crop",
      branchCount: 10,
      points: 400000,
    },
    {
      merchantId: "M003",
      name: "Kebab Mantap",
      logoUrl:
        "https://images.unsplash.com/photo-1529006557810-274b9b2fc783?w=80&h=80&fit=crop",
      branchCount: 10,
      points: 400000,
    },
    {
      merchantId: "M004",
      name: "Ramen Enak",
      logoUrl:
        "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=80&h=80&fit=crop",
      branchCount: 10,
      points: 400000,
    },
    {
      merchantId: "M005",
      name: "Teh Pinggir Wangi",
      logoUrl:
        "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=80&h=80&fit=crop",
      branchCount: 10,
      points: 400000,
    },
  ],
  meta: {
    code: "20000",
    message: "ok",
  },
};
